import { BillingOrder } from "./billingorder.model";
import { Field, ObjectType } from "./decorators";

@ObjectType()
export class AchPaymentMethod {
    @Field() achPaymentMethodId!: number;
    @Field() accountId!: number;
    @Field() nsAchInternalId?: string;
    @Field() defaultPaymentMethod!: boolean;
    @Field() description!: string;
    @Field() accountType!: string;
    @Field() accountOwnerName!: string;
    @Field() routingNumber!: string;
    @Field() lastFourDigits!: string;
    @Field() bankName!: string;
    @Field() limit!: number;
    @Field() updatedBy?: string;
    @Field() updateTime?: Date;
    /*@Field() */accountNumber?: string;
    
    default?: boolean;

    // Fake for UI to have a value to Display
    cardType?: string;
    creditCardId!: number;
    uniqueId?: number;
    paymentType?: string;
    confirmAccountNumber?: string;
    consent?: boolean;

    addToProfileAfterCheckout = false;

    // client side only
    toolTip?: string;
}

@ObjectType()
export class Card {
    @Field() creditCardId!: number;
    @Field() accountId!: number;
    @Field() cardType?: string;
    creditCardNumber?: string;
    @Field() description?: string;
    @Field() expirationMonth!: number;
    @Field() expirationYear!: number;
    // cardholderInfo?: string;
    @Field() lastFourDigits?: string;
    @Field() default?: boolean;
    @Field() cvv!: string;
    @Field() firstName!: string;
    @Field() lastName!: string;
    @Field() address1!: string;
    @Field() address2?: string;
    @Field() city!: string;
    @Field() country!: string;
    @Field() state!: string;
    @Field() zip!: string;

    @Field() nsCcInternalId?: string;

    // set this to add this card to the account during order processing.
    addCardToProfileAfterCheckout = false;
    uniqueId?: number;
    paymentType?: string;

    // client side only
    toolTip?: string;
}

export interface CardType {
    name: string;
    code: string;
}

export interface AccountType {
    name: string;
    type: string;
}

export interface PaymentMethods {
    paymentMethod: Card[] | AchPaymentMethod[]
}



/**
 * A payment - used now to initiate and pay a multi-order payment.
 */
export class Payment {

  public paymentId?: number;
  public accountId?: number;
  public company?: string;
  public numberOfCodes?: number;
  public totalPrice?: number;
  public paymentReceivedDate?: Date;
  public paymentMethod?: string;
  public lastFourDigits?: string;
  public poNumber?: string;
  public nsPaymentInternalId?: string;
  public receiptDocumentId?: number;
  public createTime?: Date;
  public updateTime?: Date;
  public updatedBy?: string;
  public billingFirstName?: string;
  public billingLastName?: string;
  public billingAddress1?: string;
  public billingAddress2?: string;
  public billingCity?: string;
  public billingZip?: string;
  public billingCountry?: string;
  public billingState?: string;
  public billingPhone?: string;
  public billingPhoneExtension?: string;
  public billingEmail?: string;
  public orders?: BillingOrder[];
}
